const useUserSearch = () => {
  const searchList = (list, input) => list.filter((x) => (`${x.fetchUser.firstname} ${x.fetchUser.lastname} ${x.fetchUser.code}`).toLowerCase().includes(input.trimStart().toLowerCase())).sort(
    (a, b) => (`${a.fetchUser.firstname} ${a.fetchUser.lastname}`).localeCompare((`${b.fetchUser.firstname} ${b.fetchUser.lastname}`)),
  );
  return searchList;
};

export default useUserSearch;
